import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import Separator from "@components/CustomTypography/Separator/Separator"
import OpenApplicationContentSection from "@components/Pages/OpenApplication/OpenApplicationContentSection/OpenApplicationContentSection"
import OpenApplicationFormSection from "@components/Pages/OpenApplication/OpenApplicationFormSection/OpenApplicationFormSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import PageSubNavigation from "@components/WebsiteRevamp/PageSubNavigation/PageSubNavigation"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import OpenApplicationCategoriesJson from "@jsons/applicationCategories.json"
import CareersData from "@jsons/careers.json"
import OpenApplicationJson from "@jsons/openApplication.json"
import React from "react"

type Props = {}

const openApplication = (props: Props) => {
	const pageData = getTranslatedPageData(CareersData, true, true)

	const AuditorsSection = getTranslatedPageData(
		OpenApplicationJson,
		true,
		true,
	)

	const AuditorsSections = getValueOrThrow(AuditorsSection.AdvancedSideAsset)

	const mainContent = getValueOrThrow(AuditorsSections[0].mainContent)

	const translatedJobCategories = getPosts("CategoriesModule", {
		data: OpenApplicationCategoriesJson,
	})

	const subMenu = getValueOrThrow(pageData.subMenu)

	return (
		<>
			<HeadMeta
				meta={AuditorsSection.metaData}
				customPath="/careers/open-application"
			/>

			<FullWidthHeader
				data={{
					title: pageData.heroData?.[0].title,
					subtitle: pageData.heroData?.[0].subtitle,
					buttons: pageData.heroData?.[0].buttons,
				}}
				position={"left"}
				size={"L"}
			/>
			<Separator size={16} />
			<PageSubNavigation data={subMenu} />

			{/* <FullWidthHeader
				data={{
					title: AuditorsSections[0].sectionTitle,
					subtitle: AuditorsSections[0].sectionBottomSubtitle,
				}}
				position={"left"}
				size={"L"}
			/> */}

			<OpenApplicationContentSection data={mainContent?.[0]} />
			<OpenApplicationFormSection categories={translatedJobCategories} />
		</>
	)
}

export default openApplication
